export const teamMembers = [
    {
        name: "Dr Kai Lukoff",
        role: "Faculty Advisor",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/KaiLukoff.jpg",
        linkedInUrl: "https://www.linkedin.com/in/klukoff/",
        bio: "Dr. Kai Lukoff is an Assistant Professor at Santa Clara University, leading the Human-Computer Interaction Lab in the Department of Computer Science & Engineering. He uses human-centered methods to research, design, and develop technologies with social impact.",
    },
    {
        name: "Ilona van der Linden",
        role: "Project Lead & Developer",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/lona.jpg",
        linkedInUrl: "https://www.linkedin.com/in/lonavdlin/",
        bio: "Lona is a San Diego native completing her last year of her masters' in Computer Science. She received her bachelors of Computer Science from the University of Wyoming. Currently, she's writing her thesis on bias in generative AI, and working as a full stack developer for SMAR. Lona loves cooking, going to concerts, and reading a good book with her cat.",
    },
    {
        name: "Kyle Zhang",
        role: "Developer",
        imageUrl: "",
        linkedInUrl: "https://www.linkedin.com/in/kyle-zhang-3a6551194/",
        bio: "Kyle is a second year Masters student studying Computer Science and Engineering. He received his Bachelors in Computer Engineering from UCI. Currently, he works as a full-stack and machine learning developer in the SCU Human-Computer Interaction Lab. He loves to go to the gym, drink coffee, and have a good time with friends.",
    },
    {
        name: "Varun Mangla",
        role: "Developer",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/VarunMangla.jpeg",
        linkedInUrl: "https://www.linkedin.com/in/varunmangla/",
        bio: "Hey, I'm Varun Mangla! I'm from Los Altos, and I'm currently a senior at Santa Clara University studying Computer Science and Engineering. I've been a member of the Human-Computer Interaction Lab at SCU for about two years, in which I work as a developer for the Systematic Mobile App Reviews project.  Outside of school, I enjoy reading fiction & sci-fi novels, playing board games, and listening to music.",
    },
    {
        name: "Jeshwin Prince",
        role: "Developer",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/jeshwin.jpg",
        linkedInUrl: "    https://www.linkedin.com/in/jeshwinprince/",
        bio: "Jeshwin Prince is a third year undergraduate student at Santa Clara University, studying Computer Science and Engineering. Currently, he works as a full-stack developer for the SCU Human-Computer Interaction Lab on the Systematic Mobile App Review project. In his free time, Jeshwin likes playing the guitar and 3D printing.",
    },
    {
        name: "Gaurav Punjabi",
        role: "UX",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/GauravPunjabi.jpeg",
        linkedInUrl: "https://www.linkedin.com/in/gaurav-punjabi-34067315a/",
        bio: "As a graduate student in computer science, I specialize in Object-Oriented Programming, encompassing code development, testing, and debugging. My keen interest lies in the intricate world of Compilers/Interpreters and their optimization. With proficiency in full-stack development, I've contributed to notable open-source projects such as phpMyAdmin and CheckStyle. I am enthusiastic about applying my skills and knowledge in diverse and dynamic tech environments.",
    },
    {
        name: "Soham Phadke",
        role: "Technical Consultant",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/SohamPhadke.jpeg",
        linkedInUrl: "https://www.linkedin.com/in/soham-phadke/",
        bio: "Hi! I'm Soham, a Computer Science and Engineering graduate from SCU who has recently discovered a passion for usability research and engineering. I'm currently working as a Research Assistant and Technical Consultant in the HCI Labs's SMAR Project, speaking with academic researchers and ensuring we incorporate their feedback in our tool's development. In my free time, I like to cook italian food, spend time with my dog and geek out over all things cars. One fun fact about me is I've been developing iOS apps for over 5 years as a hobby! ",
    },
    {
        name: "Crystal Chen",
        role: "UX & Literature Review",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/CrystalChen.jpeg",
        linkedInUrl: "https://www.linkedin.com/in/crystal-chen-637757119/",
        bio: "Crystan Chen is a member of the UX & Literature Review team for the SMAR project.",
    },
    {
        name: "Katrina Ying",
        role: "Literature Review",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/KatrinaYing.JPG",
        linkedInUrl: "https://www.linkedin.com/in/katrinaying/",
        bio: "Reliable, problem-solving researcher experienced in market research, competitive analysis, and data analysis in a fast-paced environment. Expertise in Python, SQL, and R, as well as machine learning methods. Excellent knowledge in conducting literature searches and writing manuscripts for academic research. Known for being a self-starter with excellent communication, analytical, and organizational skills. Enjoys working both independently and with others.",
    },
    {
        name: "Maggie Lau",
        role: "Literature Review",
        imageUrl: "",
        linkedInUrl: "#",
        bio: "Maggie Lau is a member of the Literature Review team for the SMAR project.",
    },
    {
        name: "Lawrence Liu",
        role: "Literature Review",
        imageUrl: "https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/lawrence.jpg",
        linkedInUrl: "https://www.linkedin.com/in/shizhaolawrenceliu/",
        bio: "Lawrence Liu is a member of the Literature Review team for the SMAR project.",
    },
];
